import { FuelRateEstimateByProgramData } from '.';

export interface FuelRateEstimateByProgramStateData {
  fuelProgramData: FuelRateEstimateByProgramData;
  loadId: string;
  loading: boolean;
  fuelError: boolean;
}
